import styled, { keyframes } from "styled-components";
import { SPACING, WEIGHTS, ANIMATION } from "../../utils/constants";
import { IconButton } from "../IconButton";

// Animations
const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const progressBar = keyframes`
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${SPACING.sm + SPACING.xs}px;
  flex-shrink: 0;

  svg {
    font-size: var(--text-xxl);
  }
`;

export const DismissButton = styled(IconButton)`
  margin-left: ${SPACING.sm + SPACING.xs}px;
  color: inherit;

  &:hover:not(:disabled) {
    background: color-mix(in srgb, currentColor 12%, transparent);
    color: inherit;
  }
`;

export const TextWrapper = styled.p`
  color: inherit;
  font-size: var(--text-base);
  font-weight: ${WEIGHTS.medium};
  line-height: 1.5;
  margin: 0;
  flex: 1;
  min-width: 0;
  word-break: break-word;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);

  [data-theme="dark"] & {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }
`;

export const ProgressBar = styled.div<{ $duration: number }>`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: currentColor;
  opacity: 0.4;
  border-radius: 0 0 12px 12px;
  animation: ${progressBar} ${({ $duration }) => $duration}ms linear forwards;
`;

export const Wrapper = styled.div`
  position: relative;
  padding: ${SPACING.md}px;
  box-shadow: var(--shadow-large);
  border-radius: 12px;
  min-width: 320px;
  max-width: 480px;
  animation: ${slideIn} ${ANIMATION.duration.moderate}
    ${ANIMATION.easing.easeOut};
  backdrop-filter: blur(12px) saturate(180%);
  overflow: hidden;

  @media (max-width: 768px) {
    min-width: 280px;
    max-width: 100%;
  }
`;

export const SuccessWrapper = styled(Wrapper)`
  color: var(--notification-success-text);
  border: 2px solid var(--notification-success-border);
  background: linear-gradient(
    135deg,
    var(--notification-success-background-start) 0%,
    var(--notification-success-background-end) 100%
  );
`;

export const InfoWrapper = styled(Wrapper)`
  color: var(--notification-info-text);
  border: 2px solid var(--notification-info-border);
  background: linear-gradient(
    135deg,
    var(--notification-info-background-start) 0%,
    var(--notification-info-background-end) 100%
  );
`;

export const WarningWrapper = styled(Wrapper)`
  color: var(--notification-warning-text);
  border: 2px solid var(--notification-warning-border);
  background: linear-gradient(
    135deg,
    var(--notification-warning-background-start) 0%,
    var(--notification-warning-background-end) 100%
  );
`;

export const ErrorWrapper = styled(Wrapper)`
  color: var(--notification-error-text);
  border: 2px solid var(--notification-error-border);
  background: linear-gradient(
    135deg,
    var(--notification-error-background-start) 0%,
    var(--notification-error-background-end) 100%
  );
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.xs}px;
`;

export const NotificationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 9999999999999999999;
  position: fixed;
  gap: ${SPACING.md}px;
  top: 2%;
  right: 2%;
`;
